import { componentsThemeMap } from '../../componentsThemeMap.js';
import { CTAButtons } from '../../ui/CTAButtons.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
function TabCard({
  children,
  navLink,
  navLinkLabel,
  style = 'default'
}) {
  const colors = componentsThemeMap[style];
  return /*#__PURE__*/jsxs(Fragment, {
    children: [children, navLink && navLinkLabel && /*#__PURE__*/jsx(CTAButtons, {
      ctaButtonLabel: navLinkLabel,
      ctaButtonUrl: navLink,
      contentBackground: colors.background
    })]
  });
}
export { TabCard };
//# sourceMappingURL=TabCard.js.map
